import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";
import { FlagRow } from "./Flags";

export const About = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <section id="about" ref={ref} className="relative py-28 md:py-40" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-square w-full overflow-hidden rounded-[2rem] border border-white/10 clip-notch bg-[#050713]">
            <motion.img style={{ y: imgY }} src="/img/aura-agency-square.jpg" alt="Agenzia Aura_" className="absolute inset-0 h-[108%] w-full object-cover -top-[4%]" data-testid="about-agency-photo" />
            <div className="absolute inset-x-0 bottom-0 p-5 pt-16 bg-gradient-to-t from-[#050713] via-[#050713]/70 to-transparent">
              <FlagRow className="justify-between gap-2" testid="about-flag-row" />
            </div>
          </div>
        </Reveal>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal><Overline>{t.about.over}</Overline></Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-hero text-base md:text-lg font-bold uppercase tracking-[0.08em] text-chrome" data-testid="about-title">{t.about.supportOver}</h2>
          </Reveal>
          <ul className="mt-6 divide-y divide-white/10 border-y border-white/10" data-testid="about-support-list">
            {t.about.support.map((item, i) => (
              <Reveal key={item} delay={0.1 + i * 0.05}>
                <li className="group flex items-baseline gap-5 py-4 md:py-5">
                  <span className="font-mono text-xs text-sky-300 w-7 shrink-0">0{i + 1}</span>
                  <span className="font-display text-xl md:text-2xl lg:text-[1.7rem] font-bold tracking-tight text-white leading-tight transition-transform duration-500 group-hover:translate-x-2">{item}</span>
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.16}>
            <p className="mt-8 text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl">{t.about.p1}</p>
            <p className="mt-5 text-base md:text-lg text-slate-400 leading-relaxed max-w-2xl">{t.about.p2}</p>
          </Reveal>
          <Reveal delay={0.24} className="mt-10 flex flex-wrap gap-3">
            {t.about.tags.map((tag, i) => (
              <span key={tag} className="rounded-full border border-white/15 px-4 py-2 text-sm text-slate-200">
                <span className="font-mono text-sky-300 mr-2">0{i + 1}</span>{tag}
              </span>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
